import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  TextField,
  Box,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import CustomRankingInput from "../../components/formComponent/CustomRankingInput";
import { addRanking, editRanking } from "../../services/rankingsApi";
import moment from "moment";
import CustomSelect from "../../components/formComponent/CustomSelect";
import { updateCall, updateCallRecord } from "../../services/newdashboard";
import { toast } from "react-toastify";

// Parse date to get month and year
const parseDate = (date: string) => {
  const parsedDate = moment(date);
  return {
    month: parsedDate.month() + 1, // moment months are 0-based
    year: parsedDate.year(),
  };
};

type UpdateCallLeadsProps = {
  open: boolean;
  onClose: () => void;
  onSave: (data?: any) => void;
  clinicData: any;
  dateFilter: {
    startDate: string;
    endDate: string;
  };
  mode?: any;
  initialData?: any;
};

const UpdateCallLeads: React.FC<UpdateCallLeadsProps> = ({
  open,
  onClose,
  onSave,
  clinicData,
  dateFilter,
  mode = "edit",
  initialData,
}) => {
  console.log(initialData, "initialData");
  const { handleSubmit, control, reset, getValues, watch, setValue } =
    useForm<any>({
      defaultValues: {
        notes: "",
        status: "",
      },
    });

  useEffect(() => {
    if (mode === "edit" && initialData) {
      reset({
        notes: initialData.notes ?? "",
        status: initialData.newStatus ?? "",
      });
    }
  }, [initialData, mode, reset]);

  const allValues = getValues();
  const [isLoading, setIsLoading] = useState(false);
  const [isAcquisitionModalOpen, setIsAcquisitionModalOpen] = useState(false);
  const [acquisitionData, setAcquisitionData] = useState({
    firstName: "",
    lastName: "",
  });

  const handleSave = async (data: any) => {
    setIsLoading(true);
    const payload = {
      notes: data.notes,
      status: data.status,
      acquType: initialData?.acquType ?? undefined,
    };
    let response;
    if (mode == "edit") {
      response = await updateCall(
        clinicData?.uniqueId,
        initialData.id,
        payload
      );
    }
    console.log(response, "responseresponse");
    if(response?.status?.error){
      toast.error(response?.status?.msg);
      setIsLoading(false);
      onClose();
      return;
    }

    if (response?.status?.msg === "Success") {
      toast.success("Acquisition updated successfully");
      onSave(data);
      onClose();
      reset();
      setIsLoading(false);
    } else {
      toast.error("Failed to update acquisition");
      setIsLoading(false);
      onClose();
    }
  };

  const handleClose = () => {
    onClose();
    setIsAcquisitionModalOpen(false);
    reset(); // Reset the form when closing
  };

  const handleStatusChange = (value: string) => {
    if (value === "Acquisition") {
      setIsAcquisitionModalOpen(true);
    }
  };

  const handleAcquisitionSubmit = async (e: React.FormEvent) => {
    // e.preventDefault();
    setIsLoading(true);
    const res = await updateCallRecord(clinicData?.uniqueId, initialData?.id, {
      ...acquisitionData,
      status: "Acquisition",
    });
    if (res?.status?.msg === "Success") {
      setIsAcquisitionModalOpen(false);
      setAcquisitionData({ firstName: "", lastName: "" });
      toast.success("Acquisition updated successfully");
      handleClose();
      onSave();
    } else {
      toast.error("Failed to update acquisition");
      setIsLoading(false);
      onClose();
      setIsAcquisitionModalOpen(false);
      setAcquisitionData({ firstName: "", lastName: "" });
    }
    // try {

    // } catch (error) {
    //   console.error("Error submitting acquisition form:", error);
    // } finally {
    //   setIsLoading(false);
    //   toast.error("Failed to update acquisition");
    //   onClose();
    //     setIsAcquisitionModalOpen(false);
    //   setAcquisitionData({ firstName: "", lastName: "" });
    // }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          style: { borderRadius: "10px" },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#194e5b",
            color: "white",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          }}
        >
          Update Acquisition
        </DialogTitle>
        <DialogContent sx={{ marginTop: "10px" }}>
          <Controller
            name="notes"
            control={control}
            rules={{ required: false }}
            render={({
              field: { onChange, onBlur, value, name, ref },
              fieldState,
            }) => (
              <CustomRankingInput
                name="notes"
                label="Notes"
                placeholder="Enter notes"
                field={{ onChange, onBlur, value, name, ref }}
                fieldState={fieldState}
              />
            )}
          />
          <div className="px-6" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <CustomSelect
              name="status"
              control={control}
              label="Status"
              rules={{ required: true }}
              onChange={(e: any) => handleStatusChange(e.target.value)}
              options={[
                { value: "select", label: "Select" },
                { value: "SPAM", label: "SPAM" },
                { value: "Existing Patient", label: "Existing Patient" },
                { value: "New Lead", label: "New Lead" },
                { value: "Campaign", label: "Campaign" },
                { value: "Opportunity Lost", label: "Opportunity Lost" },
                { value: "Repeat Call", label: "Repeat Call" },
                { value: "Clinic Follow Up", label: "Clinic Follow Up" },
                { value: "Patient Follow Up", label: "Patient Follow Up" },
                { value: "Acquisition", label: "Acquisition" },
              ]}
              className="w-full"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <button
            onClick={handleClose}
            className="btn btn-sm"
            style={{ backgroundColor: "#c9eeeb", color: "#0E3843" }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit(handleSave)}
            style={{ backgroundColor: "#0E3843" }}
            className="btn btn-sm bg-[#0E3843] min-w-[120px] rounded-md text-white border hover:bg-[#0A2A30]"
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : mode === "edit" ? (
              "Update Acquisition"
            ) : (
              "Save Acquisition"
            )}
          </button>
        </DialogActions>
      </Dialog>

      {/* Acquisition Modal */}
      <Dialog
        open={isAcquisitionModalOpen}
        onClose={() => setIsAcquisitionModalOpen(false)}
        maxWidth="sm"
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "600px",
            height: "100%",
            maxHeight: "300px",
          },
        }}
        fullWidth
      >
        <DialogTitle>Add Acquisition Details</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <div>
              <label htmlFor="firstName" className="form-label">
                First Name *
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                required
                value={acquisitionData.firstName}
                onChange={(e) =>
                  setAcquisitionData({
                    ...acquisitionData,
                    firstName: e.target.value,
                  })
                }
              />
            </div>
            <div className="">
              <label htmlFor="lastName" className="form-label">
                Last Name *
              </label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                required
                value={acquisitionData.lastName}
                onChange={(e) =>
                  setAcquisitionData({
                    ...acquisitionData,
                    lastName: e.target.value,
                  })
                }
              />
            </div>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <button
            className="btn btn-sm text-[#0E3843] rounded-md  min-w-[120px]"
            style={{ backgroundColor: "#c9eeeb", color: "#0E3843" }}
            onClick={() => setIsAcquisitionModalOpen(false)}
          >
            Cancel
          </button>
          <button
            onClick={handleAcquisitionSubmit}
            style={{ backgroundColor: "#0E3843" }}
            className="btn btn-sm bg-[#0E3843] min-w-[120px] rounded-md text-white border hover:bg-[#0A2A30]"
          >
            {isLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Submit"
            )}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateCallLeads;
